import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  for: "goal",
  class: "leading-7 text-sm font-medium text-gray-500"
}, " 学習時間の比率 ", -1)
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "mr-3 text-gray-400 w-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subjects, (subject) => {
        return (_openBlock(), _createBlock("div", {
          key: subject.name,
          class: "flex items-center my-2"
        }, [
          _createVNode("div", _hoisted_4, _toDisplayString(subject.name), 1),
          _createVNode("input", {
            type: "number",
            disabled: _ctx.subjects.length === 1,
            name: `ratio_${subject.name}`,
            placeholder: "1",
            value: subject.ratio,
            class: ["flex-grow bg-primary-100 border focus:border-primary-500 h-11 py-1 rounded-md focus:border-primary-500 text-base outline-none appearance-none py-1 px-3 leading-8 transition-border duration-300", { 'text-gray-300': _ctx.subjects.length === 1 }],
            onBlur: 
            e =>
              _ctx.update({
                name: subject.name,
                ratio: +e.target.value
              })
          
          }, null, 42, ["disabled", "name", "value", "onBlur"])
        ]))
      }), 128))
    ])
  ]))
}